import React, { useState } from "react";
import { Link } from "react-scroll";
import { scrollDuration } from "../../../config/commonConfig";
import { Tooltip } from "../../Tooltip";

const BottomHeader = () => {
  const [isNavModalClose, setIsNavModalClose] = useState(true);

  return (
    <header id="header" className="sticky-top">
      <nav className="primary-menu navbar navbar-expand-lg text-uppercase navbar-line-under-text fw-600">
        <div className="container position-relative">
          <div className="col-auto col-lg-2 d-inline-flex ps-lg-0">
            <Link
              className="logo"
              title="Sina Khanjani"
              smooth="easeInOutQuint"
              duration={scrollDuration}
              style={{ cursor: "pointer" }}
              to="home"
              onClick={(e) => {
                e.preventDefault();
                setIsNavModalClose(true);
              }}
            />
          </div>
          <div className="col col-lg-8 navbar-accordion px-0">
            <button
              className={"navbar-toggler ms-auto collapsed " + (isNavModalClose ? "" : "show")}
              type="button"
              onClick={() => setIsNavModalClose(!isNavModalClose)}
            >
              <span />
              <span />
              <span />
            </button>
            <div
              id="header-nav"
              className={"collapse navbar-collapse justify-content-center " + (isNavModalClose ? "" : "show")}
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="home" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    خانه
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="about" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    درباره من
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="services" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    خدمات
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="resume" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    رزومه
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="portfolio" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    پروژه‌ها
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="faq" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    سوالات متداول
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-auto col-lg-2 d-flex justify-content-end ps-0">
            <ul className="social-icons">
              <li className="social-icons-github">
                <Tooltip text="GitHub" placement="bottom">
                  <a
                    href="https://github.com/sinakhanjani?tab=repositories"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-github" />
                  </a>
                </Tooltip>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default BottomHeader;
